export let SECUREAT_LICENCE_PRICE = 19;
